import { Toaster as Sonner, ToasterProps } from 'sonner'
import { useThemeStore } from '../ToggleTheme'

const Toaster = ({ ...props }: ToasterProps) => {
    const { theme = 'system' } = useThemeStore()

    return (
        <Sonner
            theme={theme as ToasterProps['theme']}
            className="toaster group"
            richColors
            style={
                {
                    '--normal-bg': 'var(--popover)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                } as React.CSSProperties
            }
            {...props}
        />
    )
}

export { Toaster }
